import { useSkaldElements } from "@skaldaura/devkit"
import { ReactNode, useEffect } from "react"
import ScrollChildren from "./scrollChildren"
import "./scrollSection.scss"

interface IProps {
    zoneName: string,
    topInsertedElements?:ReactNode[],
    firstIsLoaded?: ()=>void,
}

export default function ScrollSectionWitthChildren({zoneName, topInsertedElements, firstIsLoaded}:IProps) {
    const [elements, fetchingOver] = useSkaldElements(zoneName)

    useEffect(() => {
        if (fetchingOver && firstIsLoaded) {
            firstIsLoaded()
        }
    }, [fetchingOver])
    


    return (
        <div id={`${zoneName.replaceAll(" ", "_")}`} className="scroll-section">
            {topInsertedElements && [topInsertedElements]}
            {elements.map((element) => {
                return <ScrollChildren key={element.elementid} element={element} />
            })}
        </div>
    )
}